import ArgumentLabel from '../arguments/ArgumentLabel.jsx';
import ArgumentWrapper from '../arguments/ArgumentWrapper.jsx';
import Button from '../Button.jsx';

const PanelButton = ({ label, icon, description, valid, helpIconContext, onClick, disabled, labelProps = {}, className = '', title, loading = false, children, buttonProps = {} }) => {
  return (
    <ArgumentWrapper className={className}>
      <ArgumentLabel className="small-gap" label={label} icon={icon} description={description} valid={valid} helpIconContext={helpIconContext} {...labelProps} title={title}>
        <Button size={'sm'} icon={icon} onClick={onClick} disabled={disabled} loading={loading} {...buttonProps}>
          {children}
        </Button>
      </ArgumentLabel>
    </ArgumentWrapper>
  );
};

export default PanelButton;
